import React, { useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useTitle } from "modules/common";
import { useDispatch } from "react-redux";
import { AppRoutes } from "routing";
import { sessionCache, signInUser } from "modules/auth";

export const SignInAd: React.FC = () => {
    useTitle("Prijava - eSavjetnik");

    const dispatch = useDispatch();
    const session = sessionCache().getSession();
    const loginInitiated = useRef(false);

    useEffect(() => {
        // Prevent multiple calls - only initiate login once
        if (!session && !loginInitiated.current) {
            loginInitiated.current = true;
            dispatch(signInUser({}));
        }
    }, [dispatch, session]);

    return <Redirect to={AppRoutes.Home} />;
};
